// src/components/ReportUpdateToast.tsx
import React, { useState, useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './ReportUpdateToast.css';

export interface ToastMessage {
  id: string;
  fieldLabel: string;
  message: string;
}

interface ReportUpdateToastProps {
  messages: ToastMessage[];
  onDismiss: (id: string) => void;
}

const ReportUpdateToast: React.FC<ReportUpdateToastProps> = ({ messages, onDismiss }) => {
  const { theme } = useTheme();

  useEffect(() => {
    // Auto-dismiss each toast after 4 seconds
    const timers = messages.map(msg => 
      setTimeout(() => onDismiss(msg.id), 4000)
    );
    
    return () => timers.forEach(timer => clearTimeout(timer));
  }, [messages, onDismiss]);

  if (messages.length === 0) return null;

  return (
    <div className={`report-update-toast-container ${theme}`}>
      {messages.map((msg) => (
        <div key={msg.id} className="report-update-toast">
          <div className="toast-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/>
              <path d="m9 12 2 2 4-4"/>
            </svg>
          </div>
          <div className="toast-content">
            <span className="toast-field">{msg.fieldLabel}</span>
            <span className="toast-message">{msg.message}</span>
          </div>
          <button className="toast-dismiss" onClick={() => onDismiss(msg.id)}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
      ))}
    </div>
  );
};

export default ReportUpdateToast;
